// CUSTOM JS

$(document).ready(
  function(){
  	
    $('.mobile-nav__item').click(
      function(){
        
        var $ul = $(this).find('ul');

        $('.mobile-nav__item.on').not(this).find('ul').slideUp()
        $('.mobile-nav__item.on').not(this).removeClass('on');
        
        if($(this).hasClass('on')){
          $(this).removeClass('on');
          $ul.slideUp();
        }else{
          $ul.slideDown();
          $(this).addClass('on');
        }
        
      	return false;
      }
    );
    
    
    $('.mobile-nav__item ul a').click(
      function(e){
        
        e.stopPropagation();
        
      }
    );
  
  }
);